import React, { useEffect, useState } from 'react';
import { Observer } from 'mobx-react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Typography,
  Button,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { format } from 'date-fns';
import { isMissingDeclaration } from 'typescript';
import { useRootStore } from '../../../stores/BridgeProvider';
import Spinner from '../../util/Spinner';
import { FlexDiv, WideBox } from '../../styles/styles';
import { safeFalsy, safeEval } from '../../util/UtilFunctions';
import { CustomTable } from '../../common/CustomTable';
import ConfirmDialog from '../../dealMapper/common/ConfirmDialog';

function SimpleDialog(props) {
  const { onClose, selectedRow, open } = props;
  const [loading, setLoading] = useState(true);

  const handleClose = () => {
    onClose();
    setLoading(true);
  };

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      fullWidth
      maxWidth="sm"
      scroll="body"
    >
      <DialogTitle disableTypography>
        <Typography variant="h4">Details</Typography>
      </DialogTitle>
      {!selectedRow ? (
        <Spinner />
      ) : (
        <DialogContent>
          <h5>Xero Call:</h5>
          <DialogContentText>
            {JSON.stringify(selectedRow.JsonMessage, null, 2)}
          </DialogContentText>
          <p
            style={{
              fontSize: '0.6rem',
              marginTop: '3rem',
              color: '#6f6f6f',
            }}
          >
            Created: {selectedRow.MessageTime}
          </p>
        </DialogContent>
      )}
    </Dialog>
  );
}

const logColumnsConfig = [
  {
    Header: 'Type',
    accessor: 'ObjectTypeDesc',
    id: 'ObjectTypeDesc',
    width: 90,
  },
  {
    Header: 'Timestamp',
    accessor: d => format(d.MessageTime, 'MM/DD/YYYY H:mm:ss'),
    id: 'MessageTime',
    width: 70,
  },
  {
    Header: 'Message',
    accessor: d => JSON.stringify(d.JsonMessage),
    id: 'ErrorMsg',
    width: 130,
  },
];

const IntegrationHistory = () => {
  return (
    <Observer
      render={() => {
        const history = useHistory();
        const { authStore, dataStore } = useRootStore();
        const [isLoading, setLoading] = useState(true);
        const [errors, setErrors] = useState(null);

        const [open, setOpen] = useState(false);
        const [selectedRow, setSelectedRow] = useState(null);

        const handleClick = val => {
          setOpen(true);
          setSelectedRow(val);
        };

        const handleClose = () => {
          setOpen(false);
          setSelectedRow(null);
        };

        const fetchLog = async () => {
          try {
            const { data } = await authStore.request.get(
              `${process.env.REACT_APP_API}/api/xer-task-history-log`,
            );

            console.log(data);

            const sortedDescendingTimestamps = data.sort(
              (x, y) => new Date(y.MessageTime) - new Date(x.MessageTime),
            );
            setErrors(sortedDescendingTimestamps);
          } catch (e) {
            console.error(e);
          }
        };

        useEffect(() => {
          const initialActions = async () => {
            await Promise.all([fetchLog()]);
            setLoading(false);
          };
          initialActions();
        }, []);
        if (isLoading) return <Spinner />;

        return (
          <FlexDiv>
            <WideBox style={{ maxWidth: '1500px', width: '98%' }}>
              <CustomTable
                data={errors}
                columns={logColumnsConfig}
                minRows={1}
                trClassName="react-table-hover-row dealsStep2 dealsStep3"
                getTrProps={({ row }) => ({
                  onClick: () => handleClick(row.original),
                })}
                tableHeader={<Typography variant="h2">History</Typography>}
                containerStyle={{ padding: '0 2rem' }}
              />
              <SimpleDialog
                open={open}
                onClose={handleClose}
                selectedRow={selectedRow}
              />
            </WideBox>
          </FlexDiv>
        );
      }}
    />
  );
};

export default IntegrationHistory;
